import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { applyEnvironmentOverrides, loadAppConfigFromUrl } from './app/shared/utils/app-config.util';

loadAppConfigFromUrl()
  .then((config) => {
    applyEnvironmentOverrides(config);
    return bootstrapApplication(AppComponent, appConfig(config));
  })
  .catch((err) => {
    console.error(err);
  });
